import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useChatStore = defineStore('chat', () => {
  const shouldOpenChat = ref(false)

  const openChat = () => {
    shouldOpenChat.value = true
  }

  const closeChat = () => {
    shouldOpenChat.value = false
  }

  const resetOpenChat = () => {
    shouldOpenChat.value = false
  }

  return {
    shouldOpenChat,
    openChat,
    closeChat,
    resetOpenChat
  }
})
